import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { useTrackExperimentViewedWithAuth } from '../tracking/useTrackExperimentViewedWithAuth'

// Growthbook feature flag: https://app.growthbook.io/features/jar-3638_v1_density-pacing
export const DENSITY_PACING_FLAG = 'jar-3638_v1_density-pacing'

export const DENSITY_PACING_BUCKETS = ['control', 'variant_1'] as const

export type DensityPacingBucket = (typeof DENSITY_PACING_BUCKETS)[number]

// The bucket rides on every chat turn as `pacingVariant`; cortex turns density
// pacing on only for `variant_1` (cortex/src/jarvis/agents/planner/pacing.ts).
export const useDensityPacingBucket = (): DensityPacingBucket | undefined =>
  useBucket<DensityPacingBucket>(DENSITY_PACING_FLAG) || undefined

export const useTrackDensityPacingExperiment = () => {
  const bucket = useDensityPacingBucket()
  const trackExperimentViewed = useTrackExperimentViewedWithAuth()

  useEffect(() => {
    if (bucket) trackExperimentViewed(DENSITY_PACING_FLAG)
  }, [bucket, trackExperimentViewed])
}
